import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Flag from './flag-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Flag {...validProps} />;
}
SvgComponent.iconName = 'flag';

/**
 * @deprecated This is a legacy icon
 */
export const FlagIcon = svgIconWrapper(SvgComponent);
